import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Copy } from "lucide-react";
import { api, mediaUrl } from "../../lib/api";
import { Btn, EffSelect, Loading, ErrorState, Empty } from "./ui";

export default function MediaPanel() {
  const [items, setItems] = useState([]);
  const [kind, setKind] = useState("image");
  const [busy, setBusy] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const load = async () => {
    setLoading(true);
    setError(false);
    try {
      const { data } = await api.get("/admin/media");
      setItems(Array.isArray(data) ? data : []);
    } catch (e) {
      setError(true);
      setItems([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file); fd.append("type", kind);
    try { await api.post("/admin/media", fd, { headers: { "Content-Type": "multipart/form-data" } }); toast.success("Média ajouté"); load(); }
    catch (e2) { toast.error(e2.response?.data?.detail || "Echec"); }
    finally { setBusy(false); }
  };

  const remove = async (id) => {
    if (!window.confirm("Supprimer ?")) return;
    try { await api.delete(`/admin/media/${id}`); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Suppression impossible"); }
  };
  const copy = (u) => { navigator.clipboard.writeText(u); toast.success("URL copiée"); };

  return (
    <div>
      <div className="flex items-center justify-between mb-8 flex-wrap gap-4">
        <h2 className="font-display text-3xl">Médiathèque</h2>
        <div className="flex items-center gap-3">
          <EffSelect size="sm" className="w-[130px]" value={kind} onChange={setKind}
            options={[
              { value: "image", label: "Image" }, { value: "video", label: "Vidéo" },
              { value: "audio", label: "Audio" }, { value: "cover", label: "Cover" }, { value: "logo", label: "Logo" },
            ]} />
          <label className="text-xs tracking-widest uppercase border border-white px-5 py-2.5 cursor-pointer hover:bg-white hover:text-black transition-colors">
            {busy ? "Upload..." : "Uploader"}
            <input data-testid="media-upload" type="file" className="hidden" onChange={upload} />
          </label>
        </div>
      </div>
      {loading ? <Loading /> : error ? <ErrorState onRetry={load} /> : (<>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {items.map((m) => (
          <div key={m.id} data-testid={`media-${m.id}`} className="border border-[#292929] p-3">
            <div className="aspect-square bg-[#050505] flex items-center justify-center overflow-hidden mb-3">
              {["image", "cover", "logo"].includes(m.type)
                ? <img src={mediaUrl(m.url)} alt="" className="w-full h-full object-cover" />
                : <span className="text-[10px] tracking-widest uppercase text-muted-eff">{m.type}</span>}
            </div>
            <div className="text-[11px] truncate">{m.original_filename}</div>
            <div className="text-[10px] text-muted-eff mb-2">{(m.size / 1024).toFixed(0)} Ko</div>
            <div className="flex gap-2">
              <button onClick={() => copy(mediaUrl(m.url))} className="text-muted-eff hover:text-white"><Copy className="w-4 h-4" /></button>
              <button onClick={() => remove(m.id)} className="text-muted-eff hover:text-white"><Trash2 className="w-4 h-4" /></button>
            </div>
          </div>
        ))}
      </div>
      {items.length === 0 && <Empty label="Aucun média." />}
      </>)}
    </div>
  );
}
